import React from 'react';
import { FileText, Download } from 'lucide-react';
import { H1 } from '../../components/typography';

const documents = [
  {
    title: 'Guide till bilagor',
    description: 'Komplett guide för vilka bilagor som krävs vid ansökan.',
    url: 'https://firebasestorage.googleapis.com/v0/b/hyria-58020.appspot.com/o/pdf%2Fguide-bilagor.pdf?alt=media&token=8aeb049f-bee1-43f4-b422-bea70b64ba1e'
  },
  {
    title: 'Besiktningsprotokoll',
    description: 'Protokoll för besiktning vid in- och utflytt.',
    url: 'https://firebasestorage.googleapis.com/v0/b/hyria-58020.appspot.com/o/pdf%2FBesiktningsprotokoll.pdf?alt=media&token=9e699480-e643-48dd-9926-bbac7d15ae97'
  },
  {
    title: 'Checklista för flyttstäd',
    description: 'Detaljerad checklista för städning vid utflytt.',
    url: 'https://firebasestorage.googleapis.com/v0/b/hyria-58020.appspot.com/o/pdf%2FChecklista%20flyttsta%CC%88d%20hyria.pdf?alt=media&token=6183ebc7-9589-4e59-9fa6-d2bd142420fd'
  },
  {
    title: 'Möbler & inventarier',
    description: 'Lista över möbler och inventarier som ingår i lägenheten.',
    url: 'https://firebasestorage.googleapis.com/v0/b/hyria-58020.appspot.com/o/pdf%2Fmo%CC%88bler%20inventarier.pdf?alt=media&token=eda7ecff-c3ff-4202-ae5c-d270bbb67520'
  },
  {
    title: 'Utväxling av nycklar',
    description: 'Information om hur nycklar hanteras vid in- och utflytt.',
    url: 'https://firebasestorage.googleapis.com/v0/b/hyria-58020.appspot.com/o/pdf%2Futva%CC%88xling%20av%20nycklar.pdf?alt=media&token=b008ae58-0540-4731-b5c2-f1723f250ff9'
  }
];

const DocumentPage = () => {
  return (
    <div className="max-w-4xl mx-auto p-4 md:p-8">
      <div className="mb-8">
        <H1>Dokument</H1>
        <p className="text-gray-600 mt-2">
          Viktiga dokument och guider för din lägenhet.
        </p>
      </div>

      <div className="space-y-4">
        {documents.map((doc, index) => (
          <div
            key={index}
            className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <FileText className="w-5 h-5 text-[#62B8E9]" />
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                </div>
                <p className="text-gray-600 text-sm">{doc.description}</p>
              </div>
              
              <button
                onClick={() => window.open(doc.url, '_blank')}
                className="ml-4 flex items-center gap-2 text-white px-4 py-2 rounded-lg font-medium transition-colors hover:opacity-90"
                style={{ backgroundColor: '#62B8E9', fontFamily: "'Poppins', sans-serif" }}
              >
                <Download className="w-4 h-4" />
                Ladda ner
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentPage;
